import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcMember = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.2857 6.42746C9.2857 8.00541 8.00651 9.2846 6.42856 9.2846C4.8506 9.2846 3.57142 8.00541 3.57142 6.42746C3.57142 4.8495 4.8506 3.57031 6.42856 3.57031C8.00651 3.57031 9.2857 4.8495 9.2857 6.42746Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4286 6.42746C16.4286 8.00541 15.1494 9.2846 13.5714 9.2846C11.9935 9.2846 10.7143 8.00541 10.7143 6.42746C10.7143 4.8495 11.9935 3.57031 13.5714 3.57031C15.1494 3.57031 16.4286 4.8495 16.4286 6.42746Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.42856 12.1417C1.42856 10.9583 2.38795 9.99888 3.57142 9.99888H9.2857C10.4692 9.99888 11.4286 10.9583 11.4286 12.1417V15.7132C11.4286 16.1077 11.1088 16.4275 10.7143 16.4275H2.14284C1.74836 16.4275 1.42856 16.1077 1.42856 15.7132V12.1417Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.57141 12.1417C8.57141 10.9583 9.5308 9.99888 10.7143 9.99888H16.4286C17.612 9.99888 18.5714 10.9583 18.5714 12.1417V15.7132C18.5714 16.1077 18.2516 16.4275 17.8571 16.4275H9.2857C8.89121 16.4275 8.57141 16.1077 8.57141 15.7132V12.1417Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcMember;
